// True when running as the installed app (home screen / desktop), false in a normal browser tab
export const isStandalone = () =>
  window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

// Pages on which the install banner is allowed to appear
export const INSTALL_PROMPT_PATHS = ['/timesheets', '/expenses'];

export const isInstallPromptPath = (pathname) => INSTALL_PROMPT_PATHS.includes(pathname.replace(/\/+$/, ''));
